var curIndex = 0;
var time = 800;
var slideTime = 5000;
var adImg = $("#product_switch_img>li>div>.product_switch_ad_img");
$("#product_switch_ctr>ul>li[class!='first-item'][class!='last-item']").click(function() {
    show($(this).index("#product_switch_ctr>ul>li[class!='first-item'][class!='last-item']"));
});

function show(index) {
    $.easing.def = "easeOutQuad";
    $("#drag_ctr,#drag_arrow").stop(false, true).animate({
        left: index * 65 + 0
    }, 300);
    $("#product_switch_img>li").eq(curIndex).stop(false, true).fadeOut(time);
    setTimeout(function() {
        $("#product_switch_img>li").eq(index).stop(false, true).fadeIn(time);
        adImg.eq(index).css({
            opacity: "0"
        }).stop(false, true).animate({
            opacity: "1"
        }, time);
    }, 200)
    curIndex = index;
}


$(document).on('click', '.section-scene-switch-ctr li', function () {
  const $section = $(this).closest('.section-scene-switch');
  const index = $(this).index();
  console.log(index);
  $section.find(".drag-ctr,.drag-arrow").animate({
      left: index * 65 + 0
  }, 300);
  
  $section.find(`.section-scene-switch-img li`).animate({
    opacity: 0,
    "z-index": 0
  }, function() {
    $section.find(`.section-scene-switch-img li`).eq(index).animate({
      opacity: 1,
      "z-index": 2
    })
  })
})